<div
  class="d-flex align-items-center justify-content-between _ltd"
  *ngIf="data.length"
>
  <div>
    <h3>{{ title | translate }}</h3>
  </div>
  <div>
    <a
      routerLink="/category/browse/any-department"
      [queryParams]="{ s: 'any-department', key: 'recommended_for_you' }"
      class="seeMore"
      >{{ "See More" | translate }}</a
    >
  </div>
</div>

<div class="categListing clearfix" *ngIf="data.length">
  <div class="results-base">
    <app-single-product
      class="product-base"
      *ngFor="let product of data"
      [product]="product"
      [bstCheck]="bstCheck"
    ></app-single-product>
  </div>
</div>
